export enum SettingTypeEnum {
  CompanyBranding = 'COMPANY_BRANDING',
  SingleSignOn = 'SINGLE_SIGN_ON',
  SessionControl = 'SESSION_CONTROL',
  DeviceAccessLimitation = 'DEVICE_ACCESS_LIMITATION',
  GroupCreationControl = 'GROUP_CREATION_CONTROL',
  OnlineEditors = 'ONLINE_EDITORS',
  ContributorStorageLimit = 'CONTRIBUTOR_STORAGE_LIMIT',
  CertifiedTimestamping = 'CERTIFIED_TIMESTAMPING',
  AdminRegisteredMemberVisibility = 'ADMIN_REGISTERED_MEMBER_VISIBILITY',
  ExternalFileSharingRestriction = 'EXTERNAL_FILESHARING_RESTRICTION',
  RetentionPolicies = 'RETENTION_POLICIES',
  FolderCreationPermission = 'FOLDER_CREATION_PERMISSION',
  EditorFileManagement = 'EDITOR_FILE_MANAGEMENT',
  FileTypeRestriction = 'FILE_TYPE_RESTRICTION',
  PublicAccessLink = 'PUBLIC_ACCESS_LINK',
  DownloadRestrictions = 'DOWNLOAD_RESTRICTIONS',
  ForcedAntiCaptureMode = 'FORCED_ANTICAPTURE_MODE',
  UploadWithTag = 'UPLOAD_WITH_TAG',
  TagBasedSharingRestriction = 'TAGBASED_SHARING_RESTRICTION',
  FileSalesPermission = 'FILE_SALES_PERMISSION',
  WatermarkProtection = 'WATERMARK_PROTECTION',
  FileSizeLimit = 'FILESIZE_LIMIT',
  OnBehalfMode = 'ONBEHALF_MODE',
  RemotegrantForceEncryption = 'REMOTEGRANT_FORCE_ENCRYPTION',
}
